import { CreatureSvg } from './CreatureSvg';
import { RarityPill } from './RarityPill';
import { getSpecies, RARITY_CONFIG } from '@/constants/rewards';
import type { Rarity } from '@/types/rewards';

interface NurseryCardProps {
  speciesId: string;
  rarity: Rarity;
  count: number;
  onClick: () => void;
}

export function NurseryCard({ speciesId, rarity, count, onClick }: NurseryCardProps) {
  const config = RARITY_CONFIG[rarity];
  const species = getSpecies(speciesId);

  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center rounded-2xl bg-white p-5 border transition-all hover:-translate-y-0.5 hover:shadow-md text-center cursor-pointer"
      style={{ borderColor: config.border }}
      tabIndex={0}
    >
      <div
        className="flex items-center justify-center w-[120px] h-[120px] rounded-full mb-3"
        style={{ background: `radial-gradient(circle, ${config.glow}, transparent 70%)` }}
      >
        <CreatureSvg speciesId={speciesId} size={110} />
      </div>

      <h3 className="text-lg font-display font-bold text-stone-800 mb-1">
        {species?.name ?? speciesId}
      </h3>
      <RarityPill rarity={rarity} className="mb-1" />
      {count > 1 && (
        <span className="text-xs font-semibold text-stone-400 bg-stone-100 rounded-full px-2 py-0.5 mt-1">
          &times;{count}
        </span>
      )}
    </button>
  );
}
